/** Internally used interfaces */
export type { DialogCloseEvent } from "./components/dialog/dialog";
export type {
    MenuItem,
    MenuItemEventDetail,
} from "./components/horizontal-menu-container/interface";
export type { LegendDataGroupConfigItem } from "./components/charts/interfaces/chart-data-group-config";
export type { LineChartData } from "./components/charts/line-chart/line-chart";
export type {
    Message,
    MessageFilterList,
} from "./components/message-list/interface";
export type { PopoverShowEvent } from "./components/popover/popover";
export type { RadioGroupChangeEventDetail } from "./components/radio-group/radio-group";
export type { SelectEvent } from "./components/thumbnail/thumbnail";
